import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  SHOW_LATEST_FEATURES_MODAL,
  SHOW_LATEST_FEATURES_MODAL_VERSION,
} from '../../Utils/constants';
import Carousel from '../Carousel';
import Checkbox from '../Checkbox/Checkbox';
import {
  StyledBody,
  StyledCheckboxWrapper,
  StyledContainer,
  StyledContent,
  StyledHeader,
  StyledItem,
  StyledLink,
  StyledModal,
  StyledOL,
  StyledTitle,
  StyledUL,
  StyleSubTitle,
  SyledImage,
} from './styled';
import { LATEST_FEATURES_DATA } from './dataFeatures';
import { useHistory } from 'react-router-dom';
import { isEmptyObject } from '../../Utils/utils';

const ListInfo = ({ type = '', data = [], title = '' }) => {
  const StyleList = type === 'number' ? StyledOL : StyledUL;

  return (
    <div>
      {title ? (
        <StyleSubTitle
          dangerouslySetInnerHTML={{
            __html: title,
          }}
        />
      ) : null}
      <StyleList hasTitle={title !== ''}>
        {data.map((item, index) => (
          <StyledItem key={index} dangerouslySetInnerHTML={{ __html: item }} />
        ))}
      </StyleList>
    </div>
  );
};

ListInfo.propTypes = {
  type: PropTypes.string,
  data: PropTypes.array,
  title: PropTypes.string,
};

const LatestFeaturesModal = () => {
  const history = useHistory();
  const [current, setCurrent] = useState(0);
  const [isActive, setisActive] = useState(false);
  const [isChecked, setIsChecked] = useState(false);

  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const cachedData = localStorage.getItem(SHOW_LATEST_FEATURES_MODAL);

    const defaultData = {
      enabled: true,
      version: SHOW_LATEST_FEATURES_MODAL_VERSION,
    };

    if (!cachedData || isEmptyObject(cachedData)) {
      localStorage.setItem(
        SHOW_LATEST_FEATURES_MODAL,
        JSON.stringify(defaultData)
      );
      setShowModal(true);
      return;
    }

    const parsedCacheEntry = JSON.parse(cachedData);
    if (parsedCacheEntry.version !== SHOW_LATEST_FEATURES_MODAL_VERSION) {
      localStorage.setItem(
        SHOW_LATEST_FEATURES_MODAL,
        JSON.stringify(defaultData)
      );
      setShowModal(true);
      return;
    }

    setShowModal(parsedCacheEntry.enabled ?? true);
  }, []);

  useEffect(() => {
    if (current === 1 && !isActive) {
      setisActive(true);
    }
  }, [current, setisActive, isActive]);

  const handleUpdate = active => {
    setCurrent(active);
  };

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  const handleOnClose = () => {
    localStorage.setItem(
      SHOW_LATEST_FEATURES_MODAL,
      JSON.stringify({
        enabled: !isChecked,
        version: SHOW_LATEST_FEATURES_MODAL_VERSION,
      })
    );

    setShowModal(false);
  };

  const handleOnClick = ({ url = '' }) => {
    if (url) {
      history.push(url);
    }

    setShowModal(false);
  };

  const latestFeaturesImage = LATEST_FEATURES_DATA.map(item => (
    <SyledImage key={item.alt}>
      <img src={item.banner} alt={item.alt} />
    </SyledImage>
  ));

  return (
    <StyledModal
      showClose
      className='modal'
      theme='dark'
      cardType='secondary'
      onClose={handleOnClose}
      {...{ isOpen: showModal }}
    >
      <StyledContainer>
        <StyledHeader>¡Descubre lo nuevo!</StyledHeader>
        <Carousel
          segTimer={20000}
          stopInEnd
          hideArrows
          handleUpdateParent={handleUpdate}
          banners={latestFeaturesImage}
        />

        <StyledBody>
          <StyledTitle>{LATEST_FEATURES_DATA[current].title}</StyledTitle>
          {LATEST_FEATURES_DATA[current].list ? (
            <ListInfo {...LATEST_FEATURES_DATA[current].list} />
          ) : null}
          <StyledContent
            dangerouslySetInnerHTML={{
              __html: LATEST_FEATURES_DATA[current].content,
            }}
          />
        </StyledBody>
        {LATEST_FEATURES_DATA[current].link ? (
          <StyledLink
            onClick={() =>
              handleOnClick({ url: LATEST_FEATURES_DATA[current].link.url })
            }
          >
            {LATEST_FEATURES_DATA[current].link.text}
          </StyledLink>
        ) : null}
        <StyledCheckboxWrapper>
          <Checkbox
            filled
            name='checkbox'
            defaultChecked={isChecked}
            onChange={handleCheckboxChange}
          />
          No volver a mostrar
        </StyledCheckboxWrapper>
      </StyledContainer>
    </StyledModal>
  );
};

export default LatestFeaturesModal;
